import Addandeditform from "../shared/components/Notifications/AddandEditform";
import Tableheadpanel from "../shared/components/Notifications/Tableheadpanel";
import toast from "react-hot-toast";
import useTable from "../hooks/useTable";
import useForm from "../hooks/useForm";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Datatable from "../shared/components/Notifications/Datatable";
import Cuspagination from "../shared/components/Courses/Cuspagination";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { apideleteNotifications, apigetallNotifications, apisaveNotifications, apiupdateNotifications } from "../shared/services/apiNotifications/apinotifications";


export default function Notificationspage () {

    const { page, first, rows, globalFilter, setGlobalFilter, onPage } = useTable();
    const { formdata, handlechange, visible, setVisible, openform, resetForm,editform } = useForm({});
    const queryClient = useQueryClient();
    const { data } = useQuery({ queryKey: ['notificationData', page, rows, globalFilter], queryFn: () => apigetallNotifications({ first, rows, globalFilter }) })

    const handlesave = async (e) => {
      e.preventDefault();
      console.log("Form data being saved:", formdata);
      const res = await apisaveNotifications(formdata);
      console.log("API response:", res);
      res.message == "Successfully saved" ? handlesuccess(res) : toast.error(res.message);
    }

    const handleupdate = async (e) => {
        e.preventDefault();
        const { _id, ...Othersdata } = formdata
        const res = await apiupdateNotifications(_id, Othersdata);
        res.message == "Successfully updated" ? handlesuccess(res) : toast.error(res.message);
    
      }
    
    const handlesuccess = (res) => {
        toast.success(res.message)
        queryClient.invalidateQueries('notificationData');
        resetForm();
    }

    const confirm2 = (_id) => {
        confirmDialog({
          message: 'Do you want to delete this record?',
          header: 'Delete Confirmation',
          icon: 'pi pi-info-circle',
          defaultFocus: 'reject',
          acceptClassName: 'p-button-danger bg-red-500 ml-2 text-white py-2 px-3',
          rejectClassName: 'ml-2  py-2 px-3',
          accept: () => { handledelete(_id) }
        });
      };
      const handledelete = async (_id) => {
        const res = await apideleteNotifications(_id);
        res.message == "Successfully deleted" ? handlesuccess(res) : toast.error(res.message);
      }

    return (
        <>
        <Addandeditform visible={visible} setVisible={setVisible} formdata={formdata} handlechange={handlechange} handlesave={handlesave} handleupdate={handleupdate} />
        <Tableheadpanel setGlobalFilter={setGlobalFilter} openform={openform} />
        <Datatable data={data} editform={editform} confirm2={confirm2} />
         {data?.totallength > 0 && (<Cuspagination page={page} rows={rows} onPage={onPage} totallength={data?.totallength} />)}
        <ConfirmDialog />
        </>
    )
}